import React from "react";

function ShareIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				fill="#1F8268"
				d="M12 10.757c-.507 0-.96.201-1.307.516L5.94 8.495A2.2 2.2 0 006 8.026a2.2 2.2 0 00-.06-.468l4.7-2.751c.36.335.833.542 1.36.542 1.107 0 2-.897 2-2.008a2.001 2.001 0 00-2-2.008c-1.107 0-2 .897-2 2.008 0 .16.027.315.06.469l-4.7 2.75A1.987 1.987 0 004 6.019c-1.107 0-2 .897-2 2.008 0 1.112.893 2.008 2 2.008.527 0 1-.207 1.36-.542l4.747 2.785c-.034.14-.054.288-.054.435 0 1.078.874 1.954 1.947 1.954a1.953 1.953 0 001.947-1.954A1.953 1.953 0 0012 10.757z"
			/>
		</svg>
	);
}

export default ShareIcon;
